import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ContactHeader from './ContactHeader';
import Link from './Link';
import TextRow from './TextRow';

const ProfileBase = styled.div`
  flex: 1;
  padding: 0 5px;
`;

const Profile = styled(ProfileBase)`
  display: flex;
  padding: 0 5px;
`;

const Training = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 96px;
  padding: 0 5px;
`;

const Wrapper = styled.div`
  display: flex;
  margin: 36px 0;
  padding: 0 0 36px 0;
  border-bottom: 1px solid ${props => props.theme.color.borderPrimary};
`;

const ResultsRow = ({
  className,
  companyName,
  email,
  imageUrl,
  name,
  phone,
  showTraining,
  title,
  training = [],
  website
}) => (
  <Wrapper className={className}>
    <Profile>
      <div>
        {name && <ContactHeader>{name}</ContactHeader>}
        {title && <TextRow>{title}</TextRow>}
        {companyName && <TextRow>{companyName}</TextRow>}
      </div>
    </Profile>
    <ProfileBase>
      {email && (
        <Link label="Email" url={`mailto:${email}`}>
          {email}
        </Link>
      )}
      {phone && (
        <Link label="Phone" url={`tel:${phone}`}>
          {phone}
        </Link>
      )}
      {website && (
        <Link label="Website" url={`//${website}`}>
          {website}
        </Link>
      )}
    </ProfileBase>
    {showTraining && (
      <Training>
        {Array.isArray(training) &&
          training.map((t, i) => <TextRow key={i}>{t}</TextRow>)}
      </Training>
    )}
  </Wrapper>
);

ResultsRow.propTypes = {
  className: PropTypes.string,
  companyName: PropTypes.string,
  email: PropTypes.string,
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  showTraining: PropTypes.bool,
  title: PropTypes.string,
  training: PropTypes.arrayOf(PropTypes.string),
  website: PropTypes.string
};

export default ResultsRow;
